import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LoadingController, ModalController} from '@ionic/angular';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {WsTaskDTOModel} from '../../models/ws-task-DTO.model';
import {JobListService} from '../../services/database/resource/job-list.service';
import {ServiceJobDTOModel} from '../../models/service-job-DTO.model';
import {GeneralService} from '../../services/general.service';
import {LegacyJobDetailPage} from '../../modals/legacy-job-detail/legacy-job-detail.page';
import {TestConnectionService} from '../../services/test-connection.service';
import {PopulateTasksService} from '../../services/workshopServices/populate-tasks.service';
import {EquipmentSelect} from '../../modals/equipment-select/equipment-select';
import {StateManagerService} from '../../services/state-manager.service';
import {ConfigurationModel} from '../../models/configuration.model';
import {ProductSelectPage} from '../../modals/product-select/product-select.page';
import { DocumentTypes } from 'src/app/definitions/document-types';

@Component({
    selector: 'select-plant',
    templateUrl: './select-plant.component.html',
    styleUrls: ['./select-plant.component.scss'],
})
export class SelectPlantComponent implements OnInit {

    @Input() document: DocumentModel;
    @Output() equipChanged: EventEmitter<WsTaskDTOModel[]> = new EventEmitter<WsTaskDTOModel[]>();
    detailsArr: DetaillineDTOModel[] = [];
    detailLine = new DetaillineDTOModel();
    legacyJobs: ServiceJobDTOModel[];
    loading: any;
    configuration: ConfigurationModel;

    constructor(private modalController: ModalController,
                private loki: LokijsService,
                private jobListService: JobListService,
                private loadingController: LoadingController,
                private generalServices: GeneralService,
                private testConnection: TestConnectionService,
                private populateTasks: PopulateTasksService,
                public docTypes: DocumentTypes,
                private stateManager: StateManagerService) {
    }

    
    ngOnInit() {
        this.configuration = this.stateManager.getCollection('configuration');
        console.log(this.configuration);

    }

    async addEquipmentModal(ind: number) {
        let page = null;
        if (ind === 1) {
            page = EquipmentSelect;
        }
        if (ind === 2) {
            page = ProductSelectPage;
        }
        const modal = await this.modalController.create({
            component: page,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'detailLine': this.detailLine,
                'detailsArr': this.detailsArr,
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log(dataReturned.data);
                this.document.serviceJob.servicedItem = dataReturned.data;
                if (!this.document.serviceJob.servicedItem.plantOrProductId) {
                    this.document.serviceJob.servicedItem.plantOrProductId = this.document.serviceJob.servicedItem.id;
                }
                this.populateTasks.populateTasks(this.document.serviceJob.servicedItem.pdesc, this.document.serviceJob.jobTypeId);
            }
        });
        return await modal.present();
    }

    cancelModal() {
        this.modalController.dismiss();
    }

    async checkServeConnection(plantOrProductId: number) {
        let conn = null;
        await this.testConnection.pingServer().then(res => {
            conn = res;
        });
        console.log(conn);
        if (conn) {
            this.fetchLegacyJobs(plantOrProductId);
        } else {
            if (!this.configuration.offLineMode) {
                this.generalServices.createToast('No connection to the server');
            }
        }
    }

    async fetchLegacyJobs(plantOrProductId: number) {
        this.loadingController.create({
            message: 'Please wait...',
            translucent: true,
            cssClass: 'custom-class custom-loading'
        }).then((overlay) => {
            this.loading = overlay;
            this.loading.present();
        });
        try {
            await this.jobListService.getJobHistory(plantOrProductId).then(res => {
                this.legacyJobs = res as ServiceJobDTOModel[];
            });
            if (this.legacyJobs.length > 0) {
                this.openHistory();
            } else {
                this.generalServices.createToast('No history for this plant item');
            }
        } catch (e) {
            this.generalServices.createToast('No connection with the server');
        } finally {
            this.loading.dismiss();
        }
    }

    async openHistory() {
        const modal = await this.modalController.create({
            component: LegacyJobDetailPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'jobList': this.legacyJobs,
                'document': this.document
            }
        });
        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                console.log(dataReturned);
            }
        });
        return await modal.present();
    }
}
